<template>
  <w-dialog :show="show"
            show-close
            box-style="width: 587px;"
            title="修改定额"
            :wallStyle="{zIndex: 1009}"
            footer-style="padding-bottom: 24px;border-top: 0;"
            @close="cancelHandle">
    <div class="dialog-body--database__edit">
      <table class="ui-table revise-table" width="100%" cellspacing="0" cellpadding="0">
        <tbody>
        <tr>
          <td class="font-center ui-w60">
            名称
          </td>
          <td>
            <w-input
              type="textarea"
              rows="3"
              v-model="formData.description"
            ></w-input>
            <!--<textarea class="ui-textarea dialog-width name-height"-->
                      <!--v-model="formData.description">-->
            <!--</textarea>-->
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <template slot="footer">
      <w-button type="primary" size="small" @click="submitHandle">确认</w-button>
      <w-button size="small"  @click="cancelHandle">取消</w-button>
    </template>
  </w-dialog>
</template>
<script>
import databaseEditMixin from '@/assets/mixins/database-edit'
export default {
  name: 'DialogEditQuota',
  mixins: [databaseEditMixin],
  data () {
    return {
      pageType: 'quota'
    }
  }
}
</script>
<style lang="less" type="text/less">
</style>
